import type {UpdateLeadFormPayload} from "./update-lead.schema";
import type {UpdateLeadRequest} from "@project/sdk/sales";

export const updateLeadMapper = {
  toSdk: (payload: UpdateLeadFormPayload): UpdateLeadRequest => ({
    company: {
      companyName: payload.companyName,
      partyProfile: {
        address: {address: payload.address},
        country: payload.country,
        phone: {
          regionCode: payload.phonePrefix,
          nationalNumber: payload.phoneNumber,
        },
        websiteUrl: payload.websiteUrl,
      },
    },
    environments: payload.type,
    logoUrl: payload.logoUrl,
  }),
};
